export const partnerTrackingTypes = {
  NONE: 0,
  INIT: 1
};
